const API_URI = process.env.API_URI || '/api';
const TOKEN = process.env.STRAPI_API_TOKEN;

export async function fetchFromServer(url: string) {
  if (!TOKEN) {
    return Promise.resolve();
  }

  return fetch(`${API_URI}/${url}`, {
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
    .then((x) => {
      return x.json();
    })
    .then((data) => {
      if (data.errors) {
        throw new Error(
          `GraphQL errors occurred:\n${data.errors.map((x: any) => x.message).join('\n')}`
        );
      }
      return data;
    });
}

export const fetchFromClient = async (
  method: string,
  url: string,
  data?: {},
  headers?: {}
): Promise<any> => {
  if (!headers) {
    headers = {
      Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${TOKEN}`,
    };
  } else {
    headers = {
      Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${TOKEN}`,
      ...headers,
    };
  }

  let isError = false;
  const params = { method, headers };
  let body;

  if (data) {
    body = JSON.stringify(data);
  }

  return fetch(`${API_URI}${url}`, { ...params, body })
    .then((response) => {
      isError = !response.ok;
      if (!response.ok) {
        return response.json();
      } else {
        if (response.statusText === 'No Index') {
          return response.ok;
        } else {
          return response.json();
        }
      }
    })
    .then((response) => {
      if (!isError) {
        return response;
      } else {
        let errorMessage = '';
        JSON.stringify(response, (key, value) => {
          if (typeof value === 'string') {
            errorMessage += errorMessage ? `, ${value}` : value;
          }
          return value;
        });
        return new Error(errorMessage);
      }
    })
    .catch((error) => {
      console.error(error);
      return new Error('Something went wrong. Please contact our system administrator.');
    });
};
